import { Fragment, memo, ReactElement, useEffect, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import Form from './form';
import { FilterGeneralityVM } from 'subscription/view-models/common-interface-subscription';

interface AccordionFilterProps {
  onChange: (
    key: keyof FilterGeneralityVM,
    value: FilterGeneralityVM[keyof FilterGeneralityVM]
  ) => void;
  values?: FilterGeneralityVM;
  disabled?: boolean;
  onChangeFields: (values: FilterGeneralityVM) => void;
  onSearch: () => void;
}

const AccordionFilterComponent = ({
  onChange,
  values,
  disabled,
  onChangeFields,
  onSearch,
}: AccordionFilterProps): ReactElement => {
  const [open, setOpen] = useState<boolean>(!disabled);

  useEffect(() => {
    if (disabled) {
      setOpen(false);
    }
  }, [disabled]);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="filter"
          id="filter"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Form
            onChange={onChange}
            values={values}
            disabled={disabled}
            onChangeFields={onChangeFields}
            onSearch={() => {
              setOpen(false);
              onSearch();
            }}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionFilterComponent.displayName = 'Filtri persona';

const AccordionFilter = memo(AccordionFilterComponent);

export default AccordionFilter;
